import { getAppConfig } from './utils/app.config.util';

export const LANGUAGE_DEFAULT = 'en';

export const ANALYTICS_TRACKING_ID = getAppConfig('ANALYTICS_TRACKING_ID');

export const SERVER_API_URL = getAppConfig('SERVER_API_URL');

export const SHARED_WEB_ASSETS_URL = getAppConfig('SHARED_WEB_ASSETS_URL');

export const AUTH_DOMAIN = getAppConfig('AUTH_DOMAIN');
export const AUTHENTICATION_URL = getAppConfig('AUTHENTICATION_URL');

// Okta OIDC (Authorization Code + PKCE). OKTA_ISSUER must be a custom authorization server.
export const OKTA_ISSUER = getAppConfig('OKTA_ISSUER');
export const OKTA_CLIENT_ID = getAppConfig('OKTA_CLIENT_ID');
export const ENDSESSION_ENDPOINT = getAppConfig('ENDSESSION_ENDPOINT');

export const REVOCATION_ENDPOINT = getAppConfig('REVOCATION_ENDPOINT');

export const COMMUNITY_URL = getAppConfig('COMMUNITY_URL');
export const SUPPORT4U_URL = getAppConfig('SUPPORT4U_URL');


export const INVOICES_ENDPOINT = getAppConfig('INVOICES_ENDPOINT');
export const DOWNLOAD_INVOICE_ENDPOINT = getAppConfig('DOWNLOAD_INVOICE_ENDPOINT');

export const REPORTS_LIST_ENDPOINT = getAppConfig('REPORTS_LIST_ENDPOINT');
export const REPORTS_DETAIL_ENDPOINT = getAppConfig('REPORTS_DETAIL_ENDPOINT');

export const USER_LIST_ENDPOINT = getAppConfig('USER_LIST_ENDPOINT');
export const EXPORT_USERS_TO_EXCEL_ENDPOINT = getAppConfig('EXPORT_USERS_TO_EXCEL_ENDPOINT');
export const USER_PROFILES_ENDPOINT = getAppConfig('USER_PROFILES_ENDPOINT');
export const USER_PRODUCTS_ENDPOINT = getAppConfig('USER_PRODUCTS_ENDPOINT');
export const BILLING_PLATFORM_ROLES_ENDPOINT = getAppConfig('BILLING_PLATFORM_ROLES_ENDPOINT');
export const LEARNING_ROLES_ENDPOINT = getAppConfig('LEARNING_ROLES_ENDPOINT');
export const USER_ADMINISTRATORS_ENDPOINT = getAppConfig('USER_ADMINISTRATORS_ENDPOINT');
export const EMAIL_SUBSCRIPTIONS_ENDPOINT = getAppConfig('EMAIL_SUBSCRIPTIONS_ENDPOINT');
export const USER_COUNTRIES_ENDPOINT = getAppConfig('USER_COUNTRIES_ENDPOINT');
export const ACCOUNT_ENDPOINT = getAppConfig('ACCOUNT_ENDPOINT');
export const SUCCESS_MANAGER_ENDPOINT = getAppConfig('SUCCESS_MANAGER_ENDPOINT');
export const HIPPO_CONTENT_ENDPOINT = getAppConfig('HIPPO_CONTENT_ENDPOINT');
export const NEWS_ENDPOINT = getAppConfig('NEWS_ENDPOINT');
export const PRODUCTS_ENDPOINT = getAppConfig('PRODUCTS_ENDPOINT');
export const NOTIFICATIONS_ENDPOINT = getAppConfig('NOTIFICATIONS_ENDPOINT');
export const CLOUD_ENDPOINT = getAppConfig('CLOUD_ENDPOINT');
export const SEARCH_ENDPOINT = getAppConfig('SEARCH_ENDPOINT');
export const PORTALS_ENDPOINT = getAppConfig('PORTALS_ENDPOINT');
export const COMMUNITIES_ENDPOINT = getAppConfig('COMMUNITIES_ENDPOINT');
export const UNIVERSITY_ENDPOINT = getAppConfig('UNIVERSITY_ENDPOINT');
export const SUPPORT4YOU_ENDPOINT = getAppConfig('SUPPORT4YOU_ENDPOINT');
export const U4CPP_DOMAIN = getAppConfig('U4CPP_DOMAIN');
export const SEARCH_ARTICLE_URL = getAppConfig('SEARCH_ARTICLE_URL');
export const SETTIGNS_VIDEO_URL = getAppConfig('SETTIGNS_VIDEO_URL');
export const MY_SOLUTIONS_VIDEO_URL = getAppConfig('MY_SOLUTIONS_VIDEO_URL');
export const MARKETPLACE_URL = getAppConfig('MARKETPLACE_URL');
export const MY_INSTANCES_URL = getAppConfig('MY_INSTANCES_URL');
export const CLOUD_PARTNER_PORTAL_URL = getAppConfig('CLOUD_PARTNER_PORTAL_URL');
export const BILLINGPLATFORM_URL = getAppConfig('BILLINGPLATFORM_URL');
export const USER_MANAGEMENT_VIDEO_URL = getAppConfig('USER_MANAGEMENT_VIDEO_URL');

export const MENU_ENDPOINT = getAppConfig('MENU_ENDPOINT');
export const MENU_PRODUCTS_ENDPOINT = getAppConfig('MENU_PRODUCTS_ENDPOINT');
export const SUPPORT_ENDPOINT = getAppConfig('SUPPORT_ENDPOINT');
export const SERVICE_REQUEST_URL = getAppConfig('SERVICE_REQUEST_URL');
export const PARTNER_CONTACTS_URL = getAppConfig('PARTNER_CONTACTS_URL');
export const INCIDENT_URL = getAppConfig('INCIDENT_URL');
export const TRACK_CASES_URL = getAppConfig('TRACK_CASES_URL');
export const TRACK_CASE_NO_URL = getAppConfig('TRACK_CASE_NO_URL');
export const PORTALS_URL = getAppConfig('PORTALS_URL');
export const KEEP_ALIVE_URL = getAppConfig('KEEP_ALIVE_URL');
export const KEEP_ALIVE_INTERVAL = getAppConfig('KEEP_ALIVE_INTERVAL');
export const KNOWLEDGE_SEARCH_URL = getAppConfig('KNOWLEDGE_SEARCH_URL');
export const AUTHENTICATION_CLIENT_ID = getAppConfig('AUTHENTICATION_CLIENT_ID');
export const COMMUNITY_POST_LOGOUT_REDIRECT_URL = getAppConfig('COMMUNITY_POST_LOGOUT_REDIRECT_URL');

export const PHONE_NUMBER_VALIDATION_RULE = getAppConfig('PHONE_NUMBER_VALIDATION_RULE');

export const DOCEBO_URL = getAppConfig('DOCEBO_URL');
export const INTUO_URL = getAppConfig('INTUO_URL');
export const INTUO_CATALOG_URL = getAppConfig('INTUO_CATALOG_URL');
export const SALES_URL = getAppConfig('SALES_URL');
export const RESOURCES4U_URL = getAppConfig('RESOURCES4U_URL');
export const KHOROS_COMMUNITY_URL = getAppConfig('KHOROS_COMMUNITY_URL');
export const KHOROS_COMMUNITY_SETTINGS = getAppConfig('KHOROS_COMMUNITY_SETTINGS');
export const DRUPAL_DOCUMENTS_URL = getAppConfig('DRUPAL_DOCUMENTS_URL');
export const ERPX_FILE_URL = getAppConfig('ERPX_FILE_URL');

/**
 * Route that performs the Okta part of the logout (SignoutGuard). Deliberately not called 'logout':
 * the ingress claims ^/logout for the ServiceNow leg of the chain, so that path never reaches the
 * SPA. Keep this in sync with the sysparm_goto_url in deployment.yml.
 */
export const SIGNOUT_URL = 'signout';

export const SESSION_STORAGE_ACCESS_TOKEN = 'cpp-access-token';
export const SESSION_STORAGE_ID_TOKEN = 'cpp-id-token';
export const SESSION_STORAGE_START_URL = 'cpp-start-url';
export const SESSION_STORAGE_STATE = 'cpp-state';

export const ERROR_TEXT_401 = 'Your session has expired. Redirecting to login...';
export const ERROR_TEXT_403 = 'Something went wrong. Please send an email to community4u@unit4.com if the situation persists.';
export const ERROR_TEXT_404 = 'Something went wrong. Please send an email to community4u@unit4.com if the situation persists.';
export const ERROR_TEXT_408 = 'Request has timed out. Please try again later.';
export const ERROR_TEXT_500 = 'Something went wrong. Please send an email to community4u@unit4.com if the situation persists.';
export const ERROR_NO_LABELS = 
    'Due to maintenance, this environment is currently only available in English. We apologize for any inconvenience.';

export const REQUEST_TIMEOUT_DEFAULT = 20000;

export const ICONSPRITE_PATH = '../../assets/images/sprites/cpp-sprite.svg';
export const STATIC_LABELS_PATH = '../../assets/content/labels.json';
export const STATIC_MENU_PATH = '../../assets/content/menu.json';

export const PERMITED_SUBSCRITION_LEVEL_TO_EDIT_BILLING_PLATFORM_ROLE: string[] = [];
export const PERMITED_SUBSCRITION_LEVEL_TO_EDIT_LEARNING_ROLE: string[] = ['PROFESSIONAL', 'ADVANCED', 'PARTNER'];

export type MESSAGE_TYPE = 'warning' | 'error' | 'information' | 'success';

export type USER_STATUS = 'Active' | 'Inactive' | 'Pending';

export type USER_PERMISSION = 
    'SUPPORT' | 'CLOUD' | 'NEWS' | 'USERMANAGEMENT' | 'INVOICES' | 'INTUO' | 'SUPPORT_SERVICE_NOW' | 'PARTNER' | 'SALES' | 'DOCEBO'
    | 'DOCEBO_PARTNER' ;
